import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

const toneClassMap = {
    primary: "frosted-panel--primary",
    secondary: "frosted-panel--secondary",
    neutral: "frosted-panel--neutral",
};

const depthClassMap = {
    sm: "frosted-panel--depth-sm",
    md: "frosted-panel--depth-md",
    lg: "frosted-panel--depth-lg",
};

const FrostedPanel = forwardRef(function FrostedPanel(
    { as: Component = "div", tone = "primary", depth = "md", flat = false, className = "", children, ...rest },
    ref
) {
    const classes = classNames(
        "frosted-panel",
        toneClassMap[tone] || toneClassMap.primary,
        depthClassMap[depth] || depthClassMap.md,
        flat ? "frosted-panel--flat" : null,
        className
    );

    return (
        <Component ref={ref} className={classes} {...rest}>
            {children}
        </Component>
    );
});

FrostedPanel.propTypes = {
    as: PropTypes.elementType,
    tone: PropTypes.oneOf(["primary", "secondary", "neutral"]),
    depth: PropTypes.oneOf(["sm", "md", "lg"]),
    flat: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};

FrostedPanel.defaultProps = {
    as: "div",
    tone: "primary",
    depth: "md",
    flat: false,
    className: "",
    children: null,
};

export default FrostedPanel;
